import { render, staticRenderFns } from "./CWOHome.vue?vue&type=template&id=13f72a4d&lang=pug&"
import script from "./CWOHome.vue?vue&type=script&lang=js&"
export * from "./CWOHome.vue?vue&type=script&lang=js&"
import style0 from "./CWOHome.vue?vue&type=style&index=0&theme=cwo&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports